<script>
  import Loader from "../Loader.svelte"
  import WinnerItem from "./WinnerItem.svelte"
  import LoadMoreBar from "./LoadMoreBar.svelte";
  import { perPage } from "./stores.js"

  export let params = {}

  let results = []
  let isLoading = true
  let isLoadingMore = false
  let totalPages = 0
  let page = 1

  $: fetch(`/wp-json/ya/v1/winners-search?s=${params.query}&per_page=${perPage}`)
    .then((r) => {
      totalPages = parseInt(r.headers.get('X-WP-TotalPages'), 10)
      return r.json()
    })
    .then((data) => {
      isLoading = false

      if (data) {
        results = data
      } else {
        results = []
      }
    })
  
  window.addEventListener("hashchange", (event) => {
    results = []
    isLoading = true
  });

  function appendResults() {
    isLoadingMore = true
    page++
    fetch(`/wp-json/ya/v1/winners-search?s=${params.query}&per_page=${perPage}&page=${page}`)
      .then((r) => r.json())
      .then((data) => {
        isLoadingMore = false

        if (data) {
          results = [...results, ...data]
        }
      })
  }
</script>

<div>
  <div class="ya-grid gap-y-8 mt-10">
    {#if isLoading}
      <Loader />
    {:else}
      {#if results.length}
        {#each results as item, i}
          <div class="col-span-3">
            <WinnerItem 
              name={item.title}
              school={item.school}
              city={item.city}
              state={item.state}
              disciplines={item.disciplines}
              parentDisciplines={item.parent_disciplines} 
              childDisciplines={item.child_disciplines} 
              years={item.years}
              awardLevels={item.award_levels}
              subdisciplineModifier={item.subdiscipline_modifier}
            />
          </div>
        {/each}
      {:else}
        <div class="col-span-3">
          <p>Sorry, no results found. Please try changing your search parameters.</p>
        </div>
      {/if}
    {/if}
  </div>
  {#if !isLoading && results.length}
    <LoadMoreBar page={page} totalPages={totalPages} isLoadingMore={isLoadingMore} on:loadMoreClick={appendResults} />
  {/if}
</div>